define('edap-ua-integration',['edap'], function(edap) {
    'use strict';

    var moduleName = 'ua',
        myEdap = new edap.Scope(moduleName);

    // No-op so jshint doesn't complain
    myEdap.getScopeInfo();

    return edap;
});

